module.exports = __webpack_public_path__ + "img/32885108acb8cfb3ecbf2478736ac350.png";